import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"

import { years } from "../services/timelineService"
import FiveYearRibbon from "../images/ribbons/5year.svg"
import TenYearRibbon from "../images/ribbons/10year.svg"
import FifteenYearRibbon from "../images/ribbons/15year.svg"
import TwentyYearRibbon from "../images/ribbons/20year.svg"
import TwentyfiveYearRibbon from "../images/ribbons/25year.svg"
import ThirtyYearRibbon from "../images/ribbons/30year.svg"
import ThirtyfiveYearRibbon from "../images/ribbons/35year.svg"
import FortyYearRibbon from "../images/ribbons/40year.svg"
import FortyfiveYearRibbon from "../images/ribbons/45year.svg"

import EmployeeCard from "./EmployeeCard"
import Modal from "./Modal"

import { gsap } from "gsap"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import { FaAngleRight, FaAngleLeft } from "react-icons/fa"

gsap.registerPlugin(ScrollToPlugin)
function List(props) {
  const [showModal, setShowModal] = useState(false)
  const [selectedPerson, setSelectedPerson] = useState({})
  const [colHeight, setColHeight] = useState(0)
  const [showLeftFade, setShowLeftFade] = useState(false)
  const [showRightFade, setShowRightFade] = useState(false)

  const listDivRef = useRef(null)
  const listItemRef = useRef(null)
  const listTitleRef = useRef(null)
  const listScrollRef = useRef(null)

  useEffect(() => {
    setColHeight(
      Math.floor(
        (listDivRef.current.clientHeight - listTitleRef.current.clientHeight) /
          listItemRef.current.clientHeight
      ) - 1
    )
    document.addEventListener("resize", () => {
      setColHeight(
        Math.floor(
          (listDivRef.current.clientHeight -
            listTitleRef.current.clientHeight) /
            listItemRef.current.clientHeight
        ) - 1
      )
    })

    fadeDisplay(
      document
        .getElementsByClassName("anniversary-list__list__year")[0]
        .getBoundingClientRect(),
      document
        .getElementsByClassName("anniversary-list__list__year")
        [
          document.getElementsByClassName("anniversary-list__list__year")
            .length - 1
        ].getBoundingClientRect(),
      listScrollRef.current.getBoundingClientRect()
    )
  }, [])

  const selectRibbon = (year) => {
    let ribbon = null
    switch (year) {
      case "5":
        ribbon = FiveYearRibbon
        break
      case "10":
        ribbon = TenYearRibbon
        break
      case "15":
        ribbon = FifteenYearRibbon
        break
      case "20":
        ribbon = TwentyYearRibbon
        break
      case "25":
        ribbon = TwentyfiveYearRibbon
        break
      case "30":
        ribbon = ThirtyYearRibbon
        break
      case "35":
        ribbon = ThirtyfiveYearRibbon
        break
      case "40":
        ribbon = FortyYearRibbon
        break
      case "45":
        ribbon = FortyfiveYearRibbon
        break
      default:
        ribbon = null
    }
    return ribbon
  }

  const handleListClick = (item) => {
    setSelectedPerson(item)
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const listStyle =
    typeof props.currentSegment !== "number" ? { opacity: 1 } : null

  const fadeDisplay = (leftBox, rightBox, scrollBox) => {
    console.log("Left: ", leftBox)
    console.log("Right: ", rightBox)
    console.log("Scroll: ", scrollBox)
    // if (leftBox.left === rightBox.left && leftBox.right === rightBox.right) {
    //   setShowLeftFade(false)
    //   setShowRightFade(false)
    // } else {
    setShowLeftFade(leftBox.left !== scrollBox.left)
    setShowRightFade(!(rightBox.right - 2 < scrollBox.right))
    // }
  }

  const generateYearLists = (list) => {
    return Object.keys(list)
      .map((year) => {
        if (!isNaN(2020 - year - 1)) {
          return (
            <div
              className='anniversary-list__list__year'
              key={`anniversary-list-list-${year}`}
              id={`${2020 - 1 - year}`}
              ref={listDivRef}
              style={
                typeof props.currentSegment === "number"
                  ? { margin: "0 auto" }
                  : {}
              }
            >
              <div
                className='anniversary-list__list__year__title'
                ref={listTitleRef}
              >
                <img
                  src={selectRibbon(year)}
                  alt='ribbon'
                  className='anniversary-list__list__year__title__ribbon'
                />
                Class of {2020 - year - 1}
              </div>
              <ul style={{ columns: Math.ceil(list[year].length / colHeight) }}>
                {list[year].map((ee, i) => {
                  return (
                    <li
                      key={`list-ee-${ee.value.firstName}-${ee.value.lastName}-${i}`}
                      className='list-item'
                      ref={listItemRef}
                    >
                      <span onClick={() => handleListClick(ee)}>
                        {ee.value.firstName} {ee.value.lastName}
                      </span>
                    </li>
                  )
                })}
              </ul>
            </div>
          )
        } else {
          return null
        }
      })
      .filter((ea) => ea !== null)
  }

  const generateNav = (list) => {
    return Object.keys(list).map((year) => {
      return (
        <span
          className='anniversary-list__nav__button'
          onClick={() => {
            gsap.to(listScrollRef.current, {
              duration: 1,
              scrollTo: {
                x: Object.keys(list).reduce((out, curr) => {
                  if (parseInt(curr) < parseInt(year)) {
                    return (
                      out +
                      document
                        .getElementById(`${2020 - 1 - parseInt(curr)}`)
                        .getBoundingClientRect().width
                    )
                  } else {
                    return out
                  }
                }, 0),
                y: 0,
              },
              ease: "circ.inOut",
              onComplete: () => {
                fadeDisplay(
                  document
                    .getElementsByClassName("anniversary-list__list__year")[0]
                    .getBoundingClientRect(),
                  document
                    .getElementsByClassName("anniversary-list__list__year")
                    [
                      document.getElementsByClassName(
                        "anniversary-list__list__year"
                      ).length - 1
                    ].getBoundingClientRect(),
                  listScrollRef.current.getBoundingClientRect()
                )
              }
            })

            // listScrollRef.current.scrollTo(
            //   Object.keys(list).reduce((out, curr) => {
            //     if (parseInt(curr) < parseInt(year)) {
            //       return (
            //         out +
            //         document
            //           .getElementById(`${2020 - 1 - parseInt(curr)}`)
            //           .getBoundingClientRect().width
            //       )
            //     } else {
            //       return out
            //     }
            //   }, 0),
            //   0
            // )
            fadeDisplay(
              document
                .getElementsByClassName("anniversary-list__list__year")[0]
                .getBoundingClientRect(),
              document
                .getElementsByClassName("anniversary-list__list__year")
                [
                  document.getElementsByClassName(
                    "anniversary-list__list__year"
                  ).length - 1
                ].getBoundingClientRect(),
              listScrollRef.current.getBoundingClientRect()
            )
          }}
        >
          {2020 - 1 - year}
        </span>
      )
    })
  }

  return (
    <div
      className='anniversary-list__container anniversary-list--anim'
      style={listStyle} // set opacity based on whether it's in a timeline or not
    >
      <Modal
        show={showModal}
        onClose={handleCloseModal}
        title='List modal'
        showConfetti={true}
      >
        <EmployeeCard onClose={handleCloseModal} person={selectedPerson} />
      </Modal>

      <div
        className='anniversary-list__list'
        onWheel={(e) => {
          e.currentTarget.scrollTo(e.currentTarget.scrollLeft + e.deltaY, 0)
          fadeDisplay(
            document
              .getElementsByClassName("anniversary-list__list__year")[0]
              .getBoundingClientRect(),
            document
              .getElementsByClassName("anniversary-list__list__year")
              [
                document.getElementsByClassName("anniversary-list__list__year")
                  .length - 1
              ].getBoundingClientRect(),
            listScrollRef.current.getBoundingClientRect()
          )
        }}
        ref={listScrollRef}
      >
        {showLeftFade && (
          // <div className='anniversary-list__fade anniversary-list__fade--left'></div>
          <FaAngleLeft className='anniversary-list__fade anniversary-list__fade--left'/>
        )}
        {showRightFade && (
          // <div className='anniversary-list__fade anniversary-list__fade--right'></div>
          <FaAngleRight className='anniversary-list__fade anniversary-list__fade--right'/>
        )}
        {generateYearLists(props.list)}
      </div>
      {typeof props.currentSegment !== "number" && (
        <div className='anniversary-list__nav'>{generateNav(props.list)}</div>
      )}
    </div>
  )
}

List.propTypes = {
  currentSegment: PropTypes.number, // only passed when part of a timeline animation
  setCurrentSegment: PropTypes.func, // only passed when part of a timeline animation
  list: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  advanceSegment: PropTypes.func,
}

export default List
